import { ThreadStateEnum } from '@anecdotes/commenting';

export const MentionedThreadsFilter = 'mentioned';
export const AuditorsFilter = 'auditors';
export type CommentFilterOption = ThreadStateEnum | string;
